import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "time-value" }
const _hoisted_2 = {
  key: 1,
  class: "message-type"
}
const _hoisted_3 = { key: 3 }
const _hoisted_4 = { key: 4 }
const _hoisted_5 = { key: 5 }
const _hoisted_6 = {
  key: 6,
  class: "message-type"
}
const _hoisted_7 = {
  key: 7,
  class: "message-type"
}
const _hoisted_8 = {
  key: 8,
  class: "message-type"
}

import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import CoreUiChatHistoryMessageStatus from "~/core-ui/vue/chat/CoreUiChatHistoryMessageStatus.vue";
import CoreUiChatHistoryMessageTimeValue from "~/core-ui/vue/chat/CoreUiChatHistoryMessageTimeValue.vue";
import MyLoader from "~/cabinet/vue/interface/data/MyLoader.vue";
import {__} from "~/ts/library/Translate";


const __default__ = {
    name: "CoreUiChatHistoryMessageTime"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    message: {},
    showSeconds: { type: Boolean, default: true },
    showStatus: { type: Boolean, default: true },
    utc: { type: Boolean, default: false },
    showMessageType: { type: Boolean, default: true },
    showTranslateToggle: { type: Boolean },
    applyTranslationPatch: { type: Boolean },
    messageSourceType: {}
  },
  emits: ["update:applyTranslationPatch"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

return (_ctx: any,_cache: any) => {
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
        'time',
            ((__props.message.messageType && __props.showMessageType) || __props.showTranslateToggle || __props.message.isTranslatingNow) ? 'with-message-type' : null
        ])
  }, [
    _createElementVNode("span", _hoisted_1, [
      (__props.showTranslateToggle)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            class: "message-type cursor-pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('update:applyTranslationPatch', !__props.applyTranslationPatch)))
          }, _toDisplayString(__props.applyTranslationPatch ? _unref(__)('Показать оригинал') : _unref(__)('Показать перевод')), 1))
        : (__props.message.isTranslatingNow)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _createVNode(MyLoader),
              _createTextVNode(" " + _toDisplayString(_unref(__)("Идёт перевод")), 1)
            ]))
          : _createCommentVNode("", true),
      (__props.message.isDictationUsed)
        ? _withDirectives((_openBlock(), _createBlock(FontAwesomeIcon, {
            key: 2,
            icon: "waveform-lines",
            class: "icon mr-1",
            light: ""
          }, null, 512)), [
            [_directive_my_tooltip, _unref(__)('При отправке сообщения использовалась диктовка')]
          ])
        : _createCommentVNode("", true),
      (__props.message.reactionsHistory?.length && __props.message.reactionsHistory.find(item => !item.emoji))
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
            _withDirectives(_createVNode(FontAwesomeIcon, {
              icon: "face-dotted",
              class: "icon mr-1",
              light: ""
            }, null, 512), [
              [_directive_my_tooltip, _unref(__)('Есть удалённые реакции')]
            ])
          ]))
        : _createCommentVNode("", true),
      (__props.message.isSentBySuggest)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
            _withDirectives(_createVNode(FontAwesomeIcon, {
              icon: "bullseye-pointer",
              class: "icon mr-1",
              light: ""
            }, null, 512), [
              [_directive_my_tooltip, _unref(__)('Отправлено нажатием на саджест')]
            ])
          ]))
        : _createCommentVNode("", true),
      (__props.messageSourceType?.showIcon)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
            _withDirectives(_createVNode(FontAwesomeIcon, {
              icon: __props.messageSourceType.icon,
              class: "icon mr-1",
              light: ""
            }, null, 8, ["icon"]), [
              [_directive_my_tooltip, _unref(__)('Источник') + ': ' + __props.messageSourceType.descr.toLowerCase()]
            ])
          ]))
        : _createCommentVNode("", true),
      (__props.message.messageType && __props.showMessageType)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(__props.message.messageType.descr), 1))
        : _createCommentVNode("", true),
      (__props.message.isRemoved)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
            (__props.message.isRemoved)
              ? (_openBlock(), _createBlock(FontAwesomeIcon, {
                  key: 0,
                  class: "icon text-red",
                  icon: "times",
                  light: ""
                }))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_unref(__)("удалено")), 1)
          ]))
        : (__props.message.editHistory?.length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(__)("изменено")), 1))
          : _createCommentVNode("", true),
      (__props.message.id || __props.message.error)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
            (__props.message.isPinned)
              ? (_openBlock(), _createBlock(FontAwesomeIcon, {
                  key: 0,
                  class: "icon ml-1 mr-1 rotate-45",
                  icon: "thumbtack",
                  bold: ""
                }))
              : _createCommentVNode("", true),
            _createVNode(CoreUiChatHistoryMessageTimeValue, {
              class: "value",
              message: __props.message,
              utc: __props.utc,
              "show-seconds": __props.showSeconds
            }, null, 8, ["message", "utc", "show-seconds"]),
            (__props.message.error)
              ? (_openBlock(), _createBlock(FontAwesomeIcon, {
                  key: 1,
                  class: "icon text-red ml-1",
                  icon: "exclamation-triangle",
                  light: ""
                }))
              : (!__props.message.isSendByClient && __props.message.statusId && __props.showStatus)
                ? (_openBlock(), _createBlock(CoreUiChatHistoryMessageStatus, {
                    key: 2,
                    "status-id": __props.message.statusId,
                    class: "ml-1"
                  }, null, 8, ["status-id"]))
                : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createBlock(FontAwesomeIcon, {
            key: 10,
            class: "icon",
            icon: "clock",
            light: ""
          }))
    ])
  ], 2))
}
}

})